module.exports = __webpack_public_path__ + "img/fondo-banner-principal.08282669.png";